import { type SiteImage } from '@store/content/entities/types';
import {
    type LandingContentsSectionInner,
    type LandingContentsSectionInnerImagePositionEnum,
} from '@clients/ContentApi';
import { toAbsoluteSrc } from '@store/content';

export default class LandingSection {
    constructor(data: LandingContentsSectionInner) {
        this.id = data.id;
        this.image = data.image
            ? {
                  src: toAbsoluteSrc(data.image.url),
                  alt: data.imageAlt || '',
              }
            : undefined;
        this.content = data.content;
        this.imagePosition = data.imagePosition;
        this.backgroundColor = data.backgroundColor;
    }

    id: string;
    image?: SiteImage;
    content: string;
    imagePosition: LandingContentsSectionInnerImagePositionEnum;
    backgroundColor?: string;

    toJSON() {
        return { ...this };
    }
}
